// Indicatori fonte dati (round 2, punti 2/5): da dove arriva il billing e se
// l'anagrafica azienda è stata verificata con la CLI verifica-azienda.
import type { Proposal } from "../types";

/** Fonte del billing: ✓ API marketplace (verde) / ~ Poleepo (grigio; arancio
 *  se il canale HA un'API e l'arricchimento non è ancora passato). */
export function BillingSourceBadge({ proposal }: { proposal: Proposal }) {
  const source = proposal.billing_source ?? null;
  if (source === "manual") return null; // riga inserita a mano: fonte ovvia
  if (source === "marketplace") {
    return (
      <span
        className="text-[11px] font-medium text-emerald-700"
        title="Dati cliente dall'API diretta del marketplace"
      >
        ✓ API
      </span>
    );
  }
  if (source === "order_raw") {
    // Dal 2026-07-20 ogni canale ha un'API diretta (ManoMano e BricoBravo
    // inclusi), quindi il billing Poleepo è SEMPRE provvisorio: il ramo
    // grigio «massima fonte disponibile» non esiste più.
    return (
      <span
        className="text-[11px] text-orange-600"
        title="Billing provvisorio da Poleepo: l'arricchimento dall'API marketplace non è ancora passato"
      >
        ~ Poleepo
      </span>
    );
  }
  return (
    <span className="text-[11px] text-zinc-400" title="Billing non ancora recuperato">
      · in attesa
    </span>
  );
}

function asText(value: unknown): string | null {
  return typeof value === "string" && value ? value : null;
}

/** Anagrafica azienda verificata (VIES + visurissima): ✓ con SDI/PEC in tooltip. */
export function AnagraficaBadge({ proposal }: { proposal: Proposal }) {
  if (!proposal.anagrafica_verified || !proposal.anagrafica) return null;
  const a = proposal.anagrafica;
  const sdi = asText(a.sdi);
  const pec = asText(a.pec);
  const detail = [
    asText(a.ragione_sociale),
    sdi ? `SDI ${sdi}` : null,
    pec ? `PEC ${pec}` : null,
    a.vies_valid === true ? "VIES valido" : null,
    a.vies_valid === false ? "VIES NON valido" : null,
  ]
    .filter(Boolean)
    .join(" · ");
  return (
    <span
      className="inline-flex items-center rounded bg-emerald-500/15 px-1 py-px text-[10.5px] font-medium text-emerald-700"
      title={detail || "Anagrafica verificata"}
    >
      anagrafica ✓
    </span>
  );
}
